import { apiAxios as authAxios } from '../axios.config';

export const listSchoolQualifications = () => {
    return authAxios.get('/api/schoolQualification');
}